import { searchEntities } from '../../store/selectors/search';

export const selectContacts = (state) =>
  searchEntities(state, 'contacts', ['firstname', 'lastname', 'email']);
